__turbopack_context__.v({
  "container": "loading-progress-bar-module__BBU2Oq__container",
  "loadingText": "loading-progress-bar-module__BBU2Oq__loadingText",
  "logo": "loading-progress-bar-module__BBU2Oq__logo",
  "logoCenter": "loading-progress-bar-module__BBU2Oq__logoCenter",
  "logoContainer": "loading-progress-bar-module__BBU2Oq__logoContainer",
  "logoGlow": "loading-progress-bar-module__BBU2Oq__logoGlow",
  "logoScale": "loading-progress-bar-module__BBU2Oq__logoScale",
  "logoShimmerCore": "loading-progress-bar-module__BBU2Oq__logoShimmerCore",
  "logoShimmerGlow": "loading-progress-bar-module__BBU2Oq__logoShimmerGlow",
  "logoShimmerMask": "loading-progress-bar-module__BBU2Oq__logoShimmerMask",
  "logoShimmerSweep": "loading-progress-bar-module__BBU2Oq__logoShimmerSweep",
  "logoWrap": "loading-progress-bar-module__BBU2Oq__logoWrap",
  "overlay": "loading-progress-bar-module__BBU2Oq__overlay",
  "percentage": "loading-progress-bar-module__BBU2Oq__percentage",
  "progressBarContainer": "loading-progress-bar-module__BBU2Oq__progressBarContainer",
  "progressFill": "loading-progress-bar-module__BBU2Oq__progressFill",
  "progressGlow": "loading-progress-bar-module__BBU2Oq__progressGlow",
  "progressTrack": "loading-progress-bar-module__BBU2Oq__progressTrack",
  "spinnerContainer": "loading-progress-bar-module__BBU2Oq__spinnerContainer",
});
